import React, { FunctionComponent, useCallback } from 'react';

import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { SvgImage } from '../../../../shared/components';
import { PngImage } from '../../../../shared/components/png-image';
import { isLightTheme as selectIsLightTheme } from '../../../../shared/features/config/selectors';
import { selectNewNativeAppBannerEnabled } from '../../../../shared/features/flags/selectors';
import { isPDDUserSelector } from '../../../../shared/features/user/selectors';
import { TELEMOST_LANDING_DOWNLOAD_APP_URL } from '../../../../shared/helpers/constants';
import { i18n } from '../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../shared/helpers/metrika';
import styles from './styles.css';

interface WebNativeAppBannerProps {
    fourButtonsLayout?: boolean;
}

export const WebNativeAppBanner: FunctionComponent<WebNativeAppBannerProps> = ({ fourButtonsLayout }) => {
    const onCopyPress = useCallback(() => {
        countMetrika('main_screen', 'messenger_promo_click');
        window.open(TELEMOST_LANDING_DOWNLOAD_APP_URL, '_blank');
    }, []);
    const isNativeAppBannerEnabled = useSelector(selectNewNativeAppBannerEnabled);
    const isPdd = useSelector(isPDDUserSelector);
    const isLightTheme = useSelector(selectIsLightTheme);
    if (!isNativeAppBannerEnabled || isPdd) {
        return <></>;
    }
    return (
        <div
            className={cn(styles.webNativeAppBanner, {
                [styles.fourButtonsLayout]: fourButtonsLayout,
            })}
        >
            {isLightTheme ? (
                <PngImage className={styles.qr} name="nativeAppBannerQrBlack" />
            ) : (
                <PngImage className={styles.qr} name="nativeAppBannerQr" />
            )}
            <div className={styles.wrapper}>
                <div>
                    <Text as="div" className={styles.title} color="primary" typography="body-lg-bold">
                        {i18n('native-app-banner', 'title-v2')}
                    </Text>
                    <Text as="div" className={styles.description} color="secondary" typography="body-md-regular">
                        {i18n('native-app-banner', 'description-v2')}
                    </Text>
                </div>
                <Button
                    view="neutral"
                    onPress={onCopyPress}
                    className={cn('copy-native-app-link', styles['copy-native-app-link'])}
                >
                    {i18n('native-app-banner', 'download')}
                </Button>
            </div>
            <div className={styles.right}>
                <SvgImage className={styles.spot} imageName="nativeAppBannerSpot" />
                <PngImage className={styles.phone} name="nativeAppBannerPhone" />
            </div>
        </div>
    );
};
